/* eslint-disable */
import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import HotelSeo from './HotelSeo';

$(() => {
	new HotelSeo({
		el: 'body',
		hotelInfo: window.appConfig.hotelInfo,
	});
});
